<template>
  <div class="content-box full_page">
    <div>
      <woot-button
        v-if="!isAddEditForm"
        color-scheme="success"
        class-names="button--fixed-right-top"
        icon="add-circle"
        @click="openAddEditForm"
      >
        {{$t('COUPON.CREATE_MODAL.BTNS.OPEN_MODAL')}}
      </woot-button>
    </div>


    <section v-if="!isAddEditForm">
      <div class="search_container">
        <SearchInput
          :placeholder="$t('CAMPAIGN.FILTERS.SEARCH_PLACEHOLDER')"
          v-model="searchValue"
          @search="onSearch"
        />
      </div>
      <div class="campaing_filters">
        <div class="campaing_filter">
          <p class="font_regular font_500 text_12">{{$t('CAMPAIGN.FILTERS.DATE')}}</p>
          <date-range-picker
            :confirm-text="$t('CAMPAIGN.FILTERS.DATE_CONFIRM_BTN')"
            :placeholder="$t('CAMPAIGN.FILTERS.DATE_PLACEHOLDER')"
            class="font_normal"
            :value="dateRange"
            @change="handleDateChange"
            :disabledDate="disableFilterDate"
          />
        </div>
        <div class="campaing_filter">
          <p class="font_regular font_500 text_12">{{$t('COUPON.COUPON_LIST.TOOL_BAR.STATUS.LABEL')}}</p>
          <multiselect
            v-model="selectedStatus"
            :options="statusList"
            class="small-12 font_normal"
            track-by="id"
            label="title"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :placeholder="$t('COUPON.COUPON_LIST.TOOL_BAR.STATUS.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            @select="applyFilterByStatuses($event)"
          />
        </div>
        <div class="campaing_filter">
          <p class="font_regular font_500 text_12">{{$t('COUPON.COUPON_LIST.TOOL_BAR.DURATION.LABEL')}}</p>
          <multiselect
            v-model="type"
            :options="COUPON_REDEEM_LIST"
            class="small-12 font_normal"
            track-by="id"
            label="label"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :placeholder="$t('COUPON.COUPON_LIST.TOOL_BAR.DURATION.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            @select="applyFilterByType($event)"
          />
        </div>

      </div>
    </section>




    <section v-if="!isAddEditForm">
      <CouponTable
        :coupons="coupons"
        :isLoading="uiFlags.isFetching"
        :showEmptyResult="!coupons.length"
        @on-edit-click="openEditPopup"
        @on-delete-click="openDeletePopup"
        @on-info-click="openInfoPopup"
      />
    </section>

    <AddCoupon
    v-if="isAddEditForm"
    :editable_coupon="edited_coupon"
    @onClose="closeAddEditForm"
    />
    <DeleteModal
    :show="!!delete_coupon"
    :title="$t('COUPON.DELETE_MODAL.TITLE')"
    :onConfirm="onConfirmDelete"
    :onClose="onCloseDeleteModal"
    :confirmText="$t('COUPON.DELETE_MODAL.CONFIRM_BTN')"
    :rejectText="$t('COUPON.DELETE_MODAL.REJECT_BTN')"
    />
    <CouponPreview
      v-if="info_coupon"
      :isOpen="!!info_coupon"
      :coupon="info_coupon"
      @onClose="onInfoClose"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import timeMixin from 'dashboard/mixins/time';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import SearchInput from 'dashboard/components/ui/SearchInput.vue'
import DateRangePicker from "dashboard/components/ui/DateRangePicker.vue"
import {COUPON_STATUS,COUPON_KINDS, COUPON_REDEEM_LIST} from "./constant.coupon"
import InputField from '../../../../components/ui/inputs/InputField.vue'
import MultiselectDropdown from '../../../../components/ui/inputs/MultiselectDropdown.vue'
import CouponTable from "./CouponTable.vue"
import helperMixin from 'shared/mixins/helperMixin';
import AddCoupon from "./AddCoupon.vue"
import DeleteModal from "../../../../components/widgets/modal/DeleteModal.vue"
import CouponPreview from "./CouponPreview.vue";

export default {
  components:{
    TableFooter,
    SearchInput,
    DateRangePicker,
    CouponTable,
    InputField,
    MultiselectDropdown,
    AddCoupon,
    DeleteModal,
    CouponPreview,
  },
  mixins: [alertMixin,helperMixin],
  data(){
      const endDate = new Date(); // Current date
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 1); // One month ago
    return {
      isAddEditForm: false,

      searchValue:'',
      dateRange: [
        startDate,endDate
      ],
      selectedStatus:'',
      statusList:[
        ...COUPON_STATUS,
      ],
      type:'',

      edited_coupon: null,
      delete_coupon: null,
      info_coupon: null,
    }
  },
  computed:{
    ...mapGetters({
      uiFlags: "coupons/getUIFlags",
      meta: "coupons/getMeta",
      coupons: "coupons/getCoupons",
    }),
    // COUPON_KINDS(){
    //   return COUPON_KINDS.map(el=>({...el,label:this.$t(el.label)}))
    // },
    COUPON_REDEEM_LIST(){
      return COUPON_REDEEM_LIST.map(el=>({...el,label:this.$t(el.title)}))
    },
  },
  mounted(){
    this.fetchCoupons({page:0});
  },
  methods:{
    fetchCoupons(query){

      let prepareQuery = {
        page: query.page ?? this.meta.currentPage,
        start_date : query.start_date ?? this.dateRange[0],
        end_date : query.end_date ?? this.dateRange[1],
        type: query.type?? this.type?.id,
        status: query.status ?? this.selectedStatus?.id,
        search: query.search ?? this.searchValue,
      }
      const {start_date,end_date} = this.formatStartEndDate(prepareQuery.start_date,prepareQuery.end_date);
      prepareQuery = {
        ...prepareQuery,
        start_date: start_date.split('T')[0],
        end_date: end_date.split('T')[0],
      }
      this.$store.dispatch("coupons/getCoupons",this.cleanObject(prepareQuery));
    },
    onSearch(value){
      this.fetchCoupons({search:value});
    },
    handleDateChange(dateRange){
      this.dateRange = dateRange;
      this.fetchCoupons({
        start_at: dateRange[0],
        end_at: dateRange[1],
      });
    },
    disableFilterDate(date,currentValues){
      const today = new Date();
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 12*10); // 12*10 months ago// 10 year

      if (date > today) {
        return false;
      }

      if (date < threeMonthsAgo) {
        return true;
      }
      return false;
    },
    applyFilterByStatuses(selectedOption){
      this.selectedStatus = selectedOption;
      this.fetchCoupons({status:selectedOption.id});
    },
    applyFilterByType(selectedOption){
      this.sortBy = selectedOption;
      this.fetchCoupons({type:selectedOption.id});
    },
    openAddEditForm(){
      this.isAddEditForm = true;
    },
    closeAddEditForm(){
      this.edited_coupon = null;
      this.isAddEditForm = false;
    },
    openEditPopup(row_col){
      this.edited_coupon = row_col.row;
      this.openAddEditForm();
    },
    async openDeletePopup(row_col){
      this.delete_coupon = row_col.row;
    },
    onCloseDeleteModal(){
      this.delete_coupon = null;
    },
    async onConfirmDelete(){
      try {
        // open confirm popup
        await this.$store.dispatch("coupons/deleteCouponById",{coupon_id:this.delete_coupon?.id});
        this.delete_coupon = null;
        this.showAlert(this.$t('COUPON.COUPON_LIST.DELETE.SUCCESS'));
      } catch (error) {
        console.log(error);
        this.showAlert(this.$t('COUPON.COUPON_LIST.DELETE.FAIL'));
      }
    },
    onInfoClose(){
      this.info_coupon = null;
    },
    openInfoPopup(row_col){
      this.info_coupon = row_col.row;
    },
    // end methods
  },
}
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/widgets/_fonts.scss';


.search_container{
  margin-top: 16px;
  max-width: 280px;
}

.campaing_filters{
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  .campaing_filter{
    // max-width: 350px;
    p{
      margin-bottom: 8px;
    }
  }
}

</style>